import React, { useState } from 'react';
import {
	ContactInfoForm,
	UserInfoForm,
} from 'containers/pages/users/components';
import useUserEditForm from './useUserEditForm';
import { arrayOf, func, shape, string } from 'prop-types';
import LoadingBackdrop from 'components/LoadingBackdrop';
import ConfirmationDialog from 'components/confirmationDialog/ConfirmationDialog';
import { Grid } from 'components/mui';

/**
 * @component UserEditForm
 * @param {Object} props
 * @param {string} props.id
 * @param {function} props.handleMode
 * @param {UserGroup[]} props.userGroups
 * @param {function} props.onResetId
 * @returns {JSX.Element}
 */
function UserEditForm({ id, handleMode, userGroups, onResetId }) {
	const { state, handler } = useUserEditForm(id, handleMode, onResetId);
	const [complexity, setComplexity] = useState('simple');
	const handleComplexityChange = (event, newComplexity) => {
		if (newComplexity !== null) setComplexity(newComplexity);
	};

	// NEW: Folder permissions auto-save handler
	const handleFolderPermissionsAutoSave = () => {
		console.log("💾 UserEditForm: Auto-save completed for user:", state.user.id);
		// Additional success handling if needed
		// Could trigger refresh of user data, etc.
	};

	return (
		<Grid container>
			<Grid item xs={12} md={8}>
				<ContactInfoForm
					user={state.user}
					valid={state.valid}
					addressType={state.addressType}
					dispatch={handler.dispatch}
					handleForm={handler.onForm}
					onChangeValid={handler.onValid}
					onChangeTogBtn={handler.onToggleBtn}
					complexity={complexity}
					onComplexityChange={handleComplexityChange}
				/>
			</Grid>
			<Grid item xs={12} md={4}>
				<UserInfoForm
					user={state.user}
					valid={state.valid}
					canNotSave={state.canNotSave}
					handleForm={handler.onForm}
					onResetBtn={handler.onReset}
					onClickCreateUser={handler.onUpdateUser}
					userGroups={userGroups}
					onDeleteUser={handler.onClickDelete}
					complexity={complexity}
					// NEW FOLDER PERMISSIONS PROPS
					mode="edit"
					userId={state.user.id}
					onFolderPermissionsAutoSave={handleFolderPermissionsAutoSave}
				/>
			</Grid>
			<ConfirmationDialog
				open={state.pendingDeleteUserId !== ''}
				onClose={handler.onCloseDeleteConfirmation}
				onConfirm={handler.onConfirmDelete}
				title="Delete User"
			/>
			<LoadingBackdrop open={state.isLoading} />
		</Grid>
	);
}

UserEditForm.propTypes = {
	id: string,
	handleMode: func,
	userGroups: arrayOf(shape({ userId: string, roleGroupId: string })),
};

export default UserEditForm;
